<template>
  <Box>
    <BoxHead icon="fas fa-exclamation">
      Priority Recommendations
    </BoxHead>

    <BoxLoader v-if="loading" />

    <template v-else>
      <Stack
        v-if="recommendations && recommendations?.basic_recommendations?.length > 0"
        gap="2"
      >
        <Callout
          bold
          status="danger"
        >
          {{ recommendations?.basic_recommendations?.length }} items requiring attention
        </Callout>

        <ActionCallout
          v-for="(item, index) in recommendations?.basic_recommendations.slice(0, maxCount)"
          :key="index"
          :title="item.headline"
          status="success"
          :badge="item.category"
          :action="item.action"
          @click="() => {}"
        >
          {{ item.detail }}
        </ActionCallout>

        <Button
          v-if="recommendations?.basic_recommendations?.length > maxCount"
          icon-after="fas fa-arrow-right"
          :to="{ name: 'entity-recommendations' }"
        >
          View all recommendations
        </Button>
      </Stack>

      <Callout
        v-else
        status="success"
      >
        No recommendations
      </Callout>
    </template>
  </Box>
</template>

<script setup>
import { computed } from 'vue';
import { Box, BoxHead, ActionCallout, Callout, Stack, Button, BoxLoader } from '@stakeui';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const maxCount = 3;

const recommendations = computed(() => props.client?.recommendations);
</script>
